import { useEffect, useState } from "react";

const useStickyRaQButton = (): boolean => {
  const [isRaQButtonSticky, setIsRaQButtonSticky] = useState(false);

  const isButtonSticky = (): void => {
    const uspContainer = document
      .querySelector("#usp-container")
      ?.getBoundingClientRect();

    if (uspContainer && uspContainer.top <= window.innerHeight) {
      setIsRaQButtonSticky(true);
    } else {
      setIsRaQButtonSticky(false);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", isButtonSticky);
    return () => {
      window.removeEventListener("scroll", isButtonSticky);
    };
  }, []);

  return isRaQButtonSticky;
};

export default useStickyRaQButton;
